import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

function Footer() {
  const brandName = siteConfig.brandName || siteConfig.name || "";
  const logoSource =
    typeof siteConfig.logo === "string"
      ? siteConfig.logo
      : siteConfig.logo?.src;
  const logoAlt = siteConfig.logo?.alt || brandName;
  const contact = siteConfig.contact || {};
  const currencyCode = siteConfig.currency?.code || "";

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="site-footer__newsletter"
        aria-labelledby="footer-service-heading"
      >
        <div className="site-footer__newsletter-copy">
          <span className="site-footer__eyebrow">Here when you need us</span>
          <h2 id="footer-service-heading">
            Thoughtful pieces, straightforward support.
          </h2>
          <p>
            Questions about a product, delivery, or an order? Our customer care
            team is ready to help by email.
          </p>
        </div>
        <a
          className="site-footer__service-link"
          href={`mailto:${contact.email}`}
        >
          {contact.email} <span aria-hidden="true">↗</span>
        </a>
      </section>

      <div className="site-footer__main">
        <div className="site-footer__brand">
          <Link
            className="site-footer__logo"
            to="/"
            onClick={toTop}
            aria-label={`${brandName} home`}
          >
            {logoSource ? (
              <img src={logoSource} alt={logoAlt} />
            ) : (
              <span>{brandName}</span>
            )}
          </Link>
          <p>{siteConfig.description}</p>
        </div>

        <nav
          className="site-footer__column"
          aria-labelledby="footer-about-heading"
        >
          <h2 id="footer-about-heading">About</h2>
          <Link to="/about" onClick={toTop}>
            Our story
          </Link>
          <Link to="/shop" onClick={toTop}>
            Shop all
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact us
          </Link>
        </nav>

        <nav
          className="site-footer__column"
          aria-labelledby="footer-support-heading"
        >
          <h2 id="footer-support-heading">Support</h2>
          <Link to="/policies" onClick={toTop}>
            Policies &amp; legal
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Shipping
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns &amp; refunds
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms of service
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy policy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie policy
          </Link>
          <Link to="/payments" onClick={toTop}>
            Payments &amp; pricing
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            Accessibility
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
        </nav>

        <nav
          className="site-footer__column"
          aria-labelledby="footer-care-heading"
        >
          <h2 id="footer-care-heading">Customer care</h2>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
          <p>{contact.hours}</p>
          <Link to="/privacy-choices" onClick={toTop}>
            Your privacy choices
          </Link>
        </nav>
      </div>

      <div className="site-footer__bottom">
        <div
          className="site-footer__region"
          aria-label="Store region and currency"
        >
          <span>Region / currency</span>
          <strong>{currencyCode}</strong>
        </div>

        <p>
          © {new Date().getFullYear()} {brandName}. All rights reserved.
        </p>

        <div
          className="site-footer__payments"
          aria-label="Supported payment methods"
        >
          <span>Visa</span>
          <span>Mastercard</span>
          <span>American Express</span>
        </div>

        <button className="site-footer__top" type="button" onClick={toTop}>
          Back to top
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <path d="M10 16V4M5.5 8.5 10 4l4.5 4.5" />
          </svg>
        </button>
      </div>
    </footer>
  );
}

export default Footer;
